<template>
  <div class="checkin">
    <checkin-stepper/>
    <v-container class="checkin">
      <div v-if="loading">
        <v-card>
          <v-card-text>
            <div class="text-center">
              <v-progress-circular
                size="50"
                color="primary"
                indeterminate
              />
            </div>
          </v-card-text>
        </v-card>
        <checkin-bottom-navigation>
          <template v-slot:prev-button>
            <v-btn loading>
              {{ $t("commons.prev") }}
            </v-btn>
          </template>
          <template v-slot:next-button>
            <v-btn loading color="primary">
              {{ $t("commons.next") }}
            </v-btn>
          </template>
        </checkin-bottom-navigation>
      </div>

      <InvoiceAccountForm
        v-else-if="!order.ota_with_invoice_account && newRecord != null"
        :order="order"
        :invoice_account="invoice_account"
        :reservation = "reservation"
        :new_record="newRecord"
      />

      <div v-else-if="order.ota_with_invoice_account">
        <v-alert
          type="info"
          colored-border
          dense
          color="primary lighten-2"
          elevation="2"
          border="left"
        >
          {{ $t('invoice_account.hints.ota_with_invoice_account', { ota_name: order.ota }) }}
        </v-alert>
        <checkin-bottom-navigation>
          <template v-slot:prev-button>
            <v-btn @click="goToPrevStepper">
              {{ $t("commons.prev") }}
            </v-btn>
          </template>
          <template v-slot:next-button>
            <v-btn color="primary" @click="goToNextStepper">
              {{ $t("commons.next") }}
            </v-btn>
          </template>
        </checkin-bottom-navigation>
      </div>

      <div
        v-else
        class="text-center"
      >
        {{ $t("errors.invoice_account_params_not_present") }}
        <checkin-bottom-navigation>
          <template v-slot:prev-button>
            <v-btn @click="goToPrevStepper">
              {{ $t("commons.prev") }}
            </v-btn>
          </template>
          <template v-slot:next-button>
            <v-btn color="primary" @click="goToNextStepper">
              {{ $t("commons.next") }}
            </v-btn>
          </template>
        </checkin-bottom-navigation>
      </div>

    </v-container>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { orderFetchMixin } from '../../../mixins/order_fetch_mixin'
  import { orderMixin } from '../../../mixins/order_mixin'
  import { invoiceAccountMixin } from '../../../mixins/invoice_account_mixin'
  import CheckinStepper from '../../checkin/checkin_stepper'
  import CheckinBottomNavigation from '../../checkin/checkin_bottom_navigation'
  import InvoiceAccountForm from '../../invoice_accounts/invoice_account_form'

  export default {
    name: "CheckinInvoice",

    components: {
      CheckinStepper,
      InvoiceAccountForm,
      CheckinBottomNavigation
    },

    mixins: [
      orderFetchMixin,
      orderMixin,
      invoiceAccountMixin,
    ],

    async created() {
      await this.fetchOrder(this.currentOrderId, this.getFreshOrder)

      // Richiamiamo l'anagrafica fatturazione dall'ordine
      this.$store
        .dispatch('invoice_account/fetchInvoiceAccount', this.$route.params.uuid)
        .then(invoice_account => {
            this.newRecord = false
         // console.log(`checkin_invoice loaded invoice_account id ${invoice_account.id} `, invoice_account)
        }).catch( error => {
          //console.log(`Cannot fetchInvoiceAccount for order id ${this.$route.params.order_id} status ${error.status}`)
          switch (error.status) {
            case 404:
              this.$store.dispatch('invoice_account/newInvoiceAccount', this.newInvoiceAccount)
              this.newRecord = true
              break
            default:
              this.$router.push({ name: 'dashboard' })
              this.$store.dispatch('layout/replaceAlert', {
                type: 'error',
                key: 'generic_api_error'
              })
          }

          // Se non è stata trovata l'anagrafica e l'ota ha una...
          /*if (this.order.ota_with_invoice_account) {
            if (this.newRecord) {
              console.log(`invoice_account/associateInvoiceAccountFromOta ...`, this.$route.params.order_id)
              this.$store
                .dispatch('invoice_account/associateInvoiceAccountFromOta', {uuid: this.$route.params.uuid})
                .then(invoice_account => {
                  this.newRecord = false
                  console.log(`checkin_invoice associated invoice_account id ${invoice_account.id} from ota ${this.order.ota}`)
                }, err => {
                  console.log(`Cannot associateInvoiceAccountFromOta`, err)
                  this.$store.dispatch('layout/replaceAlert', {
                    type: 'error',
                    key: 'generic_api_error'
                  })
                })
            } else if (this.newRecord == null) {
              this.$store.dispatch('invoice_account/clearInvoiceAccount')
              console.log(`Something goes wrong, blank invoice account to restart`)
            } else {
              console.log(`Invoice account found`, this.invoice_account.id)
            }
          }*/
        })
    },

    updated () {
      // Casi in cui entra
      // Caso 1: quando c'è il riconoscimenti E la pratica è in signing
      // OPPURE
      // Caso 2: quando non c'è il riconoscimento E la pratica è inviata
      if((this.reservation.guests_recognition==true &&  this.reservation.customer_contract_state == "signing") ||
        (this.reservation.guests_recognition==false &&  this.reservation.customer_contract_state == "sent")) {
        this.$router.push({name: 'checkinContract'})
      }
    },

    data() {
      return {
        newRecord: null,
      }
    },

    computed: {
      ...mapState('layout', ['loading']),
      ...mapState('order', ['order']),
      ...mapState('invoice_account', ['invoice_account'])
    },

    methods: {
      ...mapActions('invoice_account', ['fetchInvoiceAccount']),
      ...mapActions('layout', ['goToPrevStepper', 'goToNextStepper']),
    }
  }
</script>
